export default {
    methods: {
        calcMarkup(markup, fallback) {
            if (!markup) return fallback || 'span'
            return markup
        },
        calcUppercase(uppercase, fallback) {
            if (!uppercase) return fallback || ''
            return 'uppercase'
        },
        calcFontSize(size, fallback) {
            if (!size) return fallback || ''
            return size
        }
    }
}
